import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { AuthGuard } from '../../abacus/guards/auth.guard'
import { PermissionGuard } from '../../abacus/guards/permission.guard'

import { CountryListComponent } from './country-list/country-list.component'

export const countryRoutes: Route[] = [
  {
    path: 'countries',
    component: CountryListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browsePolicyInitiativeTaxonomies'
    }
  },
  {
    path: 'countries/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Country',
        nameSingular: 'Country/Territory',
        namePlural: 'Countries/Territories',
        path: 'countries',
        slug: 'countries',
        title: 'Countries/Territories'
      }),
      permissions: [
        'readPolicyInitiativeTaxonomies',
        'readTools',
        'readToolUseCases',
        'readTaxonomies'
      ]
    }
  }
]
